import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { filter, mergeMap, take, takeUntil } from 'rxjs/operators';
import { CommonTournament, Tournament } from 'src/app/services/tournaments/tournaments.models';
import { environment } from 'src/environments/environment';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { tournamentsTrx } from 'src/app/router-translation.labels';
import { combineLatest, of } from 'rxjs';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { SwiperConfiguration } from 'src/app/components/games/search-game/swiper-module/swiper-config.model';

export const swiperConfig: SwiperConfiguration = {
  swiperWrapper: {
    gap: '16px',
  },
  swiperBodyWrapper: {
    height: 'auto',
    maxHeight: '400px',
    gap: '16px',
    aliginItems: 'flex-start',
  },
  
  swipeToMove: 1,
  loop: true,
  sticky: true,
}

@Component({
  selector: 'app-home-page-tournament',
  templateUrl: './home-page-tournament.component.html',
  styleUrls: ['./home-page-tournament.component.scss']
})
export class HomePageTournamentComponent extends BasePageComponent {
  tournamentTitle: string = $localize`:@@tournamentTitle:Bison Tournaments`;

  constructor(
    private tournamentService: TournamentService,
    private loginStatus: LoginStatusService,
    protected translationConfig: TranslationConfig,
    @Inject(LOCALE_ID) public locale: string,
    protected licenceService: LicenceService
  ) { super() }

  enableTournamentsDisplay = environment.enableTournamentsDisplay;
  tournmentsCount:number = 0;
  tournments: CommonTournament[] = [];
  startDate = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
  // activeTournaments: TournamentWithCountDown[] = [];
  offset = new Date().getTimezoneOffset();
  numberTournaments = 0;
  public tournamentsTrx = this.translationConfig.getTranslation(tournamentsTrx);
  public swiperConfig = swiperConfig;

  ngOnInit(): void {
    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged !== LoggedStatus.voidState),
      mergeMap((status) => {
        return combineLatest({
          tournaments: this.tournamentService.updateTournamentsStore(),
          isLogged: of(status.isLogged === LoggedStatus.logged)
        })
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.numberTournaments = resp.tournaments.length;
      this.tournments = resp.tournaments;
      if (resp.isLogged) {
        this.tournamentService.getPrivateTournaments().pipe(take(1)).subscribe(respPrivate => {
          this.numberTournaments = respPrivate.length;
          this.tournments = respPrivate;
        })
      }
      this.tournmentsCount = this.tournments.length;
    })
  }

}
